import { fetchSendTimer } from '../../repositories/public/browser-telemetry/v1/send-timer';
export var sendTelemetry = function sendTelemetry(_ref) {
  var httpApi = _ref.httpApi,
    responseTime = _ref.responseTime;
  try {
    fetchSendTimer({
      httpApi: httpApi,
      parameters: {
        key: 'newbuilding-dynamic-calltracking',
        value: responseTime
      }
    });
  } catch (e) {
    //Ничего не логируем
  }
};